document.addEventListener("DOMContentLoaded", () => {
    const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
    return; // Animations disabled as per client request
    if (!isDesktop) return;
    
    const zoomBanners = document.querySelectorAll(".zoom-banner-block");

    zoomBanners.forEach((el, index) => {
        const element = el;
        const zoomEffect = element.getAttribute("data-zoom-effect");
        const bannerScroll = element.getAttribute("data-scroll");
        const image = element.querySelector(".wp-block-cover__image-background");
        const overlay = element.querySelector(".wp-block-cover__background");
        const innerContainer = element.querySelector(".wp-block-cover__inner-container");
        let endPosition = "bottom top";

        if (bannerScroll === "scroll-added") {
            const bannerDefaultHeight = element.offsetHeight;
            endPosition = `top+=${bannerDefaultHeight} top`;
            const bannerHeight = bannerDefaultHeight * 2;
            element.style.height = `${bannerHeight}px`;
        }
        
        const tl = gsap.timeline({
            scrollTrigger: {
                id: `ZoomBanner${index + 1}`,
                trigger: element,
                start: "top top",
                end: endPosition,
                scrub: true,
                pin: true,
                pinSpacing: false
            },
        });

        if (
            zoomEffect === "zoom-in-content-fade-in" ||
            zoomEffect === "zoom-in"
        ) 
        {
            let commonSettings = {
                scale: 0.8,
                borderRadius: "18px", 
            }
            if (image) {
                gsap.set(image, commonSettings);
            }
            gsap.set(overlay, commonSettings);
        }

        if (zoomEffect === "zoom-in-content-fade-in") {
            
            gsap.set(innerContainer, { opacity: 0 });
            
            if (image) {
                tl.to(
                    image,
                    {
                        y: "0%",
                        scale: 1,
                        marginTop: "0",
                        height: "100vh",
                        borderRadius: "0",
                        duration: 1,
                        ease: "expo.inOut",
                    },
                    "="
                );
            }

            tl
            .to(
                innerContainer,
                {
                    opacity: 1,
                    duration: 0.5,
                    ease: "expo.inOut"
                },
                "="
            )
            .to(
                overlay,
                {
                    y: "0%",
                    scale: 1,
                    marginTop: "0",
                    height: "100vh",
                    borderRadius: "0",
                    duration: 1,
                    ease: "expo.inOut",
                },
                "="
            );
            

        } else if (zoomEffect === "zoom-in") {

            if (image) {
                tl.to(
                    image,
                    {
                        y: "0%",
                        scale: 1,
                        marginTop: "0",
                        height: "100vh",
                        borderRadius: "0",
                        duration: 1,
                        ease: "expo.inOut",
                    },
                    "="
                );
            }
            tl.to(
                overlay,
                {
                    y: "0%",
                    scale: 1,
                    marginTop: "0",
                    height: "100vh",
                    borderRadius: "0",
                    duration: 1,
                    ease: "expo.inOut"                    
                },
                "="
            );

        } else if (zoomEffect === "fade-in") {
            
            gsap.set(element, { opacity: 0 });
            tl.to(
                element, 
                {
                    opacity: 1,
                    duration: 1,
                    ease: "expo.inOut"
                }, 
                "="
            );
        }
    });
});
